import { create } from "zustand";

import { PaymentPlanActivationProps } from "@/client/domains/payment-plan/plan-activate-modal";
import { PermissionNoticeModalProps } from "@/client/domains/permission/ui/permission-notice-modal";

//

export interface Modals {
  activatePlan: {
    dataType: PaymentPlanActivationProps;
  };
  permissionNotice: {
    dataType: PermissionNoticeModalProps;
  };
}

//

type Data = {
  [P in keyof Modals]?: Modals[P]["dataType"];
};

interface ModalStore {
  _type: keyof Modals | null;
  data: Data | undefined;
  isAnyOpen: boolean;
  open: <K extends keyof Modals>(type: K, data: Modals[K]["dataType"]) => void;
  close: () => void;
  isOpen: <K extends keyof Modals>(type: K) => boolean;
  getData: <K extends keyof Modals>(type: K) => Modals[K]["dataType"] | undefined;
}

//

export const useModal = create<ModalStore>((set, get) => ({
  _type: null,
  data: undefined,
  isAnyOpen: false,
  open: (type, data) => set({ isAnyOpen: true, _type: type, data: { [type]: data } }),
  close: () => set({ _type: null, isAnyOpen: false, data: undefined }),
  isOpen: (type) => {
    const store = get();
    return store._type === type && store.isAnyOpen;
  },
  getData: (type) => {
    const { data } = get();
    if (data === undefined) return;
    const typedData = data[type];
    if (typedData === undefined) return;
    return typedData;
  },
}));
